import { UserSocialMediaAccountInfo } from './user-social-media-account-info.model';

export class BaseUser {
    creationTime?: Date;

    email: string;

    id: string;

    image: string;

    isBot: boolean;

    name: string;

    socialMediaAccountInfo?: UserSocialMediaAccountInfo;

    userLastActivityTime: Date;
}
